import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class RefreshPrincipalListMessage extends Message {

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('RefreshPrincipalListMessage', RefreshPrincipalListMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');